import { render, staticRenderFns } from "./ProductEditOverviewPage.vue?vue&type=template&id=57edc740"
import script from "./ProductEditOverviewPage.vue?vue&type=script&lang=js"
export * from "./ProductEditOverviewPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports